module.exports = "/static/assets/96f3b5b0b66b8145d40cb2614e7105a8.png";